import { render, staticRenderFns } from "./upload_pdfs.vue?vue&type=template&id=0e4e7867"
import script from "./upload_pdfs.vue?vue&type=script&lang=js"
export * from "./upload_pdfs.vue?vue&type=script&lang=js"
import style0 from "./upload_pdfs.vue?vue&type=style&index=0&id=0e4e7867&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports